function t(e) {
  const r = e.match(/\s[\w\W]"([\w]*)\\/g);
  return Array.isArray(r) && r.map((s) => {
    const a = s.match(/"([\w]*)\\/);
    return Array.isArray(a) ? a[1] : "";
  }) || [];
}
function o(e) {
  return e?.match(/<em\s*.*>\s*.*<\/em>/g)?.[0]?.replace("<em>", "")?.replace("</em>", "") ?? "New Security Key";
}
export {
  o as parseDeviceNameText,
  t as parseDisplayRecoveryCodesText
};
